import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "@fontsource/open-sans"; // Defaults to weight 400
import "@fontsource/open-sans/400.css"; // Specify weight
import "@fontsource/open-sans/400-italic.css"; // Specify weight and style

import "@fontsource/caveat"; // Defaults to weight 400
import "@fontsource/caveat/400.css"; // Specify weight
import {
  Email,
  Password,
  VisibilityOff,
  Visibility
} from "@mui/icons-material";
import { ToastContainer, toast } from "react-toastify";
import { initPresenceForLoggedInUser } from "../helpers/ablyPresence";

import apilink from "../globals/Baseurls";
import axios from "axios";
import { Squares } from "react-activity";
import "react-activity/dist/library.css";

const Login = () => {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [paswdOpen, setPwsdOpen] = useState(false);
  const [posting, setPosting] = useState(false);
  const navigate = useNavigate();

  const handleSignIn = () => {
   
    if (identifier === "") {
      toast.warn("Failed. Fill in your email or phone number", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    if (password === "") {
      toast.warn("Failed. Fill in your password", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    setPosting(true);
    const dataObj = {
      identifier,
      password,
    };

    console.log(dataObj);

    const baseUrl = apilink.link;
    axios
      .post(`${baseUrl}/auth/login`, dataObj)
      .then((response) => {
     
        if (response.data.user) {
          if (response.data.user.profile === null) {
            
            console.log(response.data.user);

            const user = response.data.user;
            localStorage.setItem("userSessionData", JSON.stringify({ ...user, token: response.data.token }));
            initPresenceForLoggedInUser(user.id, user.name); // <-- use await if you want

            //End Ably
            setPosting(false);
            setIdentifier("");
            setPassword("");
            navigate("/fill-profile");
            return;
          }

          if (response.data.user.profile.is_complete === 1) {
            const user = response.data.user;
            localStorage.setItem("userSessionData", JSON.stringify({ ...user, token: response.data.token }));
            initPresenceForLoggedInUser(user.id, user.name); // <-- use await if you want

            //End Ably
            setPosting(false);
            setIdentifier("");
            setPassword("");
            navigate("/discover");
          } else {
            const user = response.data.user;
            localStorage.setItem("userSessionData", JSON.stringify({ ...user, token: response.data.token }));
            initPresenceForLoggedInUser(user.id, user.name); // <-- use await if you want

            setPosting(false);
            setIdentifier("");
            setPassword("");
            navigate("/fill-profile");
          }

          return;
        } else {

          toast.warn(response.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setPosting(false);
          return;
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response.data.message === 'Invalid credentials') {
          setPosting(false);
          toast.warn("Failed. Try again with correct login details", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
        if (error.response.data.message === 'Account not activated') {
          setPosting(false);
          toast.warn("Failed. Account is not yet activated, verify using OTP to proceed", {
            position: "top-center",
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            onClose: () => {
              navigate('/otp');
            },
            theme: "light",
          });
        }
        if (error.response.data.message === 'Staff must use web portal') {
          setPosting(false);
          toast.warn("Failed. Try again with correct login details", {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      });


  };

  const handleMemberSignUp = () => {
    navigate("/register");
  };

  return (
    <>
      <div
        style={{
          flexDirection: "column",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "76px",
          paddingInline: 30,
        }}
      >
        <img
          alt="logo"
          style={{ width: "170px", height: "110px", resizeMode: "stretch" }}
          src={require("./collide.png")}
        />
        <h1
          className="navbar-brand mb-0"
          style={{ fontFamily: "Caveat", fontSize: 24 }}
        >
          <b>Swipe </b>Meet<b> Smile </b>
        </h1>
        <p
          style={{
            color: "#010832",
            fontFamily: "Open Sans",
            marginTop: "80px",
          }}
        >
          Sign In
        </p>
        <div
          style={{
            width: "320px",
            borderWidth: 1,
            borderColor: "#010832",
            backgroundColor: "#010832",
            borderRadius: 5,
            height: 50,
            marginBottom: "10px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
          }}
        >
          <div style={{
            width: "40px",
            height: 50,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}>
            <Email style={{ color: "#ffffff" }} />
          </div>
          <div style={{
            height: 50,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}>
            <input
              style={{
                height: 48.1,
                width: "279.2px",
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                border: "1px solid white",
                borderTopRightRadius: 5,
                borderBottomRightRadius: 5,
                outlineStyle: 'none',

              }}
              value={identifier}
              placeholder="Email or phone"
              onChange={(e) => { setIdentifier(e.target.value) }}
            />
          </div>
          <div></div>
        </div>
        <div
          style={{
            width: "320px",
            borderWidth: 1,
            borderColor: "#010832",
            backgroundColor: "#010832",
            borderRadius: 5,
            height: 50,
            marginBottom: "10px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
          }}
        >
          <div style={{
            width: "40px",
            height: 50,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}>
            <Password style={{ color: "#ffffff" }} />
          </div>
          <div style={{
            height: 50,
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}>
            <input
              style={{
                height: 48.6,
                width: "239.2px",
                fontFamily: "Open Sans",
                fontSize: 14,
                paddingInline: 10,
                border: "1px solid white",
                outlineStyle: 'none'
              }}
              value={password}
              type={paswdOpen ? "text" : "password"}
              placeholder="Password"
              onChange={(e) => { setPassword(e.target.value) }}
            />
          </div>
          <div style={{
            width: "40px",
            height: 48.5,
            marginTop: 0.7,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#ffffff",

            borderBottomRightRadius: "5px",
            borderTopRightRadius: "5px",

            borderBottomLeftRadius: "5px",
            borderTopLeftRadius: "5px",

          }}>
            {paswdOpen ? <>
              <Visibility onClick={() => { setPwsdOpen(!paswdOpen) }} style={{ color: "#5f5b5b" }} />
            </> : <>
              <VisibilityOff onClick={() => { setPwsdOpen(!paswdOpen) }} style={{ color: "#5f5b5b" }} />
            </>}
          </div>
          <div></div>
        </div>
        <button
          onClick={() => handleSignIn()}
          style={{
            width: "320px",
            backgroundColor: "#010832",
            borderRadius: 5,
            border: "none",
            height: 50,
            fontFamily: "Open Sans",
            fontSize: 14,
            color: "white",
            marginTop: "10px",
          }}
        >
          {posting === false && <>Sign In</>}
          {posting && (
            <>
              <Squares />
            </>
          )}
        </button>
        <p
          onClick={() => handleMemberSignUp()}
          style={{
            color: "#000000",
            fontFamily: "Open Sans",
            fontSize: 14,
            marginTop: "20px",
            alignSelf: "left",
            width: "320px",
          }}
        >
          Not yet registered &nbsp;?&nbsp; <span style={{ color: "#010832" }}>Click here to register</span>
        </p>

        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
      </div>
    </>
  );
};

export default Login;
